import { apiSlice } from "src/services/ApiSlice";
import { clearLocalStorage } from "src/utils/auth/authUtils";
import {
  authTokenKeyName,
  refreshTokenKeyName,
} from "src/utils/configs/authConfig";

const apiSliceType: any = apiSlice;
export const authMiddleware = (store: any) => (next: any) => (action: any) => {
  const result = next(action);
  // if (result.error && result.payload.status === 401) {
  //   store
  //     .dispatch(
  //       apiSliceType.endpoints.getAccessToken.initiate({
  //         refreshToken: localStorage.getItem(refreshTokenKeyName),
  //       })
  //     )
  //     .then((res: any) => {
  //       if (res?.error && res?.error?.status === 400 && res?.error?.status === 500) {
  //         clearLocalStorage();
  //         // window.location.replace("/");
  //       } else {
  //         localStorage.setItem(authTokenKeyName, res.data?.data?.token);
  //         localStorage.setItem(
  //           refreshTokenKeyName,
  //           res.data?.data?.refreshToken
  //         );
  //         localStorage.setItem(
  //           "userData",
  //           JSON.stringify({
  //             name: res?.name,
  //             mobile: res?.mobile,
  //             email: res?.email,
  //             userId: res?.userId,
  //           })
  //         );
  //         // window.location.reload();
  //       }
  //     });
  // }
  return result;
};


